module.exports = __webpack_public_path__ + "static/media/live28_06_2018.d48ecfd5.jpg";